<template>
  <v-container>
    <v-row class="justify-end mb-3 mr-1 mt-3">
      <v-btn
        height="45"
        @click="openModal('new', null)"
        class="button btn-border btn-right"
      >
        <v-icon dark> mdi-plus </v-icon>
        Nova forma de pagamento
      </v-btn>
    </v-row>
    <v-data-table
      class="table-body"
      no-data-text="Nenhuma forma de pagamento encontrada"
      loading-text="Buscando informações..."
      :headers="headersFormaPgto"
      :items="$loja_gerenciar.lista_forma_pagamento_loja"
      :items-per-page="10"
      sort-by="descricao"
      :loading="$loja_gerenciar.formaPag.formas_pgto_loading"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Formas de pagamento por página:',
      }"
    >
      <template v-slot:item.actions="{ item }" class="table-actions">
        <div style="display: flex; justify-content: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                width="30"
                small
                icon
                :loading="item.edit_button_loading"
                v-bind="attrs"
                v-on="on"
                @click="openModal('edit', item)"
                class="mr-2"
              >
                <v-icon> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                icon
                @click="
                  $loja_gerenciar.removerFormaPag(
                    item.idforma_pag,
                    'Deseja realmente excluir esta forma de pagamento?'
                  )
                "
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span>Deletar</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <FinanceiroFormasPagamentoAdd />
    <ModalConfirmacao
      :textModal="$loja_gerenciar.formaPag.text"
      @callback="$loja_gerenciar.funcaoRemoverFormaPag"
    />
  </v-container>
</template>

<script>
export default {
  name: "FormasDePagamento",
  props: {},
  components: {
    // AppBody: () => import("@/layouts/components/AppBody.vue"),
    FinanceiroFormasPagamentoAdd: () =>
      import("@/components/lojas/lojas-modal-formas-pagamento-add.vue"),
    ModalConfirmacao: () =>
      import("@/components/global/modal-confirmacao-formaPag.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Nova forma de pagamento",
          action: () => this.openModal("new", null),
        },
      ],
      headersFormaPgto: [
        {
          text: "Descrição",
          align: "center",
          sortable: false,
          value: "descricao",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  methods: {
    openModal(type, data) {
      this.$loja_gerenciar.formaPag.formas_pgto_AddEdit = type;
      if (type == "edit") {
        this.$loja_gerenciar.formaPag.cadastro.idforma_pag = data.idforma_pag;
        this.$loja_gerenciar.formaPag.cadastro.ordem = data.ordem;
        this.$loja_gerenciar.formaPag.cadastro.descricao = data.descricao;
        this.$loja_gerenciar.formaPag.cadastro.status = data.status;
        this.$loja_gerenciar.formaPag.cadastro.juros = data.juros;
        this.$loja_gerenciar.formaPag.cadastro.valor_maximo = data.valor_max;
        this.$loja_gerenciar.formaPag.cadastro.valor_minimo = data.valor_min;
        this.$loja_gerenciar.formaPag.cadastro.parcelas = data.num_parcelas;
        this.$loja_gerenciar.formaPag.cadastro.tipo = data.tipo;
      }
      this.$loja_gerenciar.formaPag.add_formas = true;
    },
  },
  mounted() {
    // this.$loja_gerenciar.getFormasPagLoja(this.$loja_gerenciar.sequenciador);
    this.$financeiro_formas_pgto.getModosPgto();
  },
  destroyed() {
    this.$financeiro_formas_pgto.limparFiltros();
  },
};
</script>
<style scoped>
.formas-pagamento-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button2 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  position: relative;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
